import { ISettingsData } from 'js/crossword/settingsData';
import { LayoutType } from 'js/crossword/gameSceneLayouts';
import OS from 'framework/utils/OS';

interface IResizeProps {
  mainArea: HTMLElement;
  clueBar: HTMLElement;
  boardRatio: number;
  settings: ISettingsData;
  boardColumn: HTMLElement;
  gameScene: HTMLElement;
  freeze: boolean;
}

export function resizeMainArea(props: IResizeProps) {
  OS.desktop ? resizeMainAreaDesktop(props) : resizeMainAreaMobile(props);
}

function resizeMainAreaDesktop({ mainArea, clueBar, boardRatio, settings }: IResizeProps): void {
  const maxBoardPercent = 75;
  const minClueColumnPercent = 20;

  const mainWidth = mainArea.clientWidth;
  const mainHeight = mainArea.clientHeight;

  // -5 for board top margin
  const boardHeight = mainHeight - clueBar.clientHeight - 5;
  const boardWidth = boardHeight * boardRatio;
  const boardPercent = Math.min(maxBoardPercent, (boardWidth / mainWidth) * 100);
  const cluesPercent = 100 - boardPercent;

  const oneColumnLayout = cluesPercent < minClueColumnPercent * 2;

  if (oneColumnLayout) {
    if (settings.leftClues) {
      mainArea.style.gridTemplateColumns = `${cluesPercent}% ${boardPercent}%`;
      settings.layout = LayoutType.LeftOneColumn;
    } else {
      mainArea.style.gridTemplateColumns = `${boardPercent}% ${cluesPercent}%`;
      settings.layout = LayoutType.RightOneColumn;
    }
    mainArea.style.gridTemplateRows = '50% 50%';
  } else {
    if (settings.leftClues) {
      mainArea.style.gridTemplateColumns = `${cluesPercent * 0.5}% ${cluesPercent * 0.5}% ${boardPercent}%`;
      settings.layout = LayoutType.LeftTwoColumns;
    } else {
      mainArea.style.gridTemplateColumns = `${boardPercent}% ${cluesPercent * 0.5}% ${cluesPercent * 0.5}%`;
      settings.layout = LayoutType.RightTwoColumns;
    }
    mainArea.style.gridTemplateRows = '100%';
  }
}

function resizeMainAreaMobile({ boardColumn, boardRatio, clueBar, gameScene, freeze }: IResizeProps): void {
  boardColumn.style.height = `${clueBar.clientHeight + window.innerWidth / boardRatio}px`;
  // gameScene.style.height = `${gameScene.scrollHeight}px`;
  window.parent.postMessage(
    JSON.stringify({
      height: freeze ? Math.round(window.innerWidth * 1.3) : gameScene.scrollHeight,
    }),
    '*',
  );
}
